import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment } from '@desbank/core/src/lib/environment';
import { StorageService } from '@desbank/core/src/lib/services/storage';
import { ForgeService } from '@desbank/core/src/lib/services/forge';
import { Observable, Subject } from 'rxjs';
import { shareReplay, switchMap, tap, take } from 'rxjs/operators';
import { Auth, AuthLogin } from './interfaces/auth.interface';
import { UserAccessHistory } from './interfaces/user-access-history.interface';
import { LoginApiService } from './login-api.service';


@Injectable({
  providedIn: 'root'
})
export class LoginService {
  public auth$: Observable<Auth>;

  private invalidUserSubject = new Subject<string>();
  public invalidUser$ = this.invalidUserSubject.asObservable();

  private token: string;
  public userLogged: string;

  constructor(
    private storageService: StorageService,
    private forgeService: ForgeService,
    private loginApiService: LoginApiService,
    @Inject('environment') private env: Environment
  ) {
  }

  public userAndPassowordValidate(auth: Auth | AuthLogin, captchaToken: string): Observable<Auth> {
    this.auth$ = this.auth(auth, captchaToken);

    this.auth$.subscribe(() => {},
      (error: HttpErrorResponse) => {
        if (401 === error.status) {
          this.invalidUserSubject.next('Usuário ou senha inválidos');
        }
    });

    return this.auth$;
  }

  public auth(auth: Auth | AuthLogin, captchaToken: string): Observable<Auth> {
    return this.loginApiService.getPublicKey()
      .pipe(
        tap((resp) => this.token = resp.token),
        switchMap(() => this.loginApiService.auth(
          this.forgeService.encryptWithPublicKey(JSON.stringify(auth), this.token),
          captchaToken
        )),
        tap((a: Auth) => this.refreshToken(a.userName)),
        shareReplay(),
        tap(() => this.storageService.cleanAllSessions()),
        tap((a: Auth) => this.storageService.setSession(this.env.authKey, a)),
      );
  }

  public refreshToken(username: string): void {
    this.storageService.setSession('userLogged', username);
    this.timeoutRefreshToken(username);
  }

  public timeoutRefreshToken(username: string): void {
    setTimeout(() => {
      const session = this.storageService.getSession(this.env.authKey);
      if (session.userName === username) {
        this.loginApiService.refreshToken(session.refreshToken).pipe(
          take(1)
        ).subscribe((resp: Auth) => {
          this.storageService.setSession(this.env.authKey, resp);
          this.timeoutRefreshToken(this.storageService.getSession('userLogged') || '');
        })
      }
    }, this.env.refeshTokenTimeout);
  }

  public sendUserAccessHistory(userAccessHistory: UserAccessHistory): Observable<any> {
    return this.loginApiService.sendUserAccessHistory(userAccessHistory);
  }
}
